import { ReloadOutlined } from '@ant-design/icons'
import { Button, Card, Result } from 'antd'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface RetryRequestProps {
  freezeReloadInMs?: number
  handleReload: () => void
}

const RetryRequest: FC<RetryRequestProps> = ({ freezeReloadInMs = 5000, handleReload }) => {
  const { t } = useTranslation()
  const [disabled, setDisabled] = useState(false)

  const handleOnClick = () => {
    setDisabled(true)
    handleReload()
    setTimeout(() => {
      setDisabled(false)
    }, freezeReloadInMs)
  }
  return (
    <Card style={{ margin: '10px 0px' }}>
      <Result
        status='warning'
        title={t('retry-error')}
        extra={
          <Button
            disabled={disabled}
            type='primary'
            key='console'
            onClick={handleOnClick}
            loading={disabled}
            icon={<ReloadOutlined />}
          ></Button>
        }
      />
    </Card>
  )
}

export default RetryRequest
